import React from 'react';
import PropTypes from 'prop-types';
import PouStocarstvo from './PouStocarstvo';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Notification from '../../../common/Notification';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {cleanJsonBody} from "../../../redux/helpers";
import {getPouStocarstvo} from "../../../redux/pouStocarstvo/reducer";
import {createPouStocarstvoRequest, fetchNewPouStocarstvo} from "../../../redux/pouStocarstvo/fetch";
import {uploadFileRequest} from "../../../redux/fileSystem/fetch";
import {getUploadedFile} from "../../../redux/fileSystem/reducer";
import {getUser} from "../../../redux/user/reducer";
import {getLookupMap} from "../../../redux/lookup/reducer";
import {fetchLookups} from "../../../redux/lookup/fetch";

export class CreatePouStocarstvo extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.savePouStocarstvo = this.savePouStocarstvo.bind(this);
        this.uploadFileStocarstvo = this.uploadFileStocarstvo.bind(this);
        this.redirectToPouStocarstvoList = this.redirectToPouStocarstvoList.bind(this);
        this.state = {notify: false, message: '', error: false};
    }

    componentWillMount() {
        const {fetchNewPouStocarstvo, fetchLookups} = this.props;
        fetchNewPouStocarstvo();
        fetchLookups();
    }

    savePouStocarstvo(values) {
        /*  Create and call updatePouStocarstvo action */
        let newValues = cleanJsonBody(JSON.parse(JSON.stringify(values)), true);
        this.props.createPouStocarstvoRequest(newValues)
        this.showNotification("Успешно креирано ПОУ сточарство!");
        setTimeout(() => this.redirectToPouStocarstvoList(), 1000); //execute greet after 2000 milliseconds (2 seconds)
    }

    uploadFileStocarstvo(file) {
        // this.props.uploadFileRequest(myInput)
        // this.showNotification("Успешно прикачен фајл");
        const myInput = document.getElementById(file);
        return uploadFileRequest(myInput).then(res => {
            this.showNotification("Успешно прикачен фајл!");
            return res
        })
    }

    redirectToPouStocarstvoList() {
        this.props.history.push(`/PouStocarstvoList`);
    }

    showNotification = (msg, err) => {
        if (err) {
            this.setState({notify: true, message: msg, error: true});
        } else {
            this.setState({notify: true, message: msg, error: false});
        }
        setTimeout(() => this.setState({notify: false, message: "", error: false}), 5000);
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    render() {
        const {notify, message, error} = this.state;
        return (
            <div>
                <Card>
                    <CardContent>
                        <h1>Креирај ПОУ сточарство</h1>
                    </CardContent>
                    {this.props.pouStocarstvo &&
                    <PouStocarstvo
                        pouStocarstvo={this.props.pouStocarstvo.pouStocarstvo}
                        createMode
                        uploadedFileId={this.props.uploadedFileId ? this.props.uploadedFileId.uploadedFileId : null}
                        uploadFile={this.uploadFileStocarstvo}
                        onSubmit={this.savePouStocarstvo}
                        onCancel={this.redirectToPouStocarstvoList}
                        user={this.props.user}
                        lookupData={this.props.lookupData}
                    />}
                </Card>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        id: id,
        pouStocarstvo: getPouStocarstvo(state),
        uploadedFileId: getUploadedFile(state),
        user: getUser(state),
        lookupData: getLookupMap(state)
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchNewPouStocarstvo,
        createPouStocarstvoRequest,
        uploadFileRequest,
        fetchLookups
    }, dispatch)
}

CreatePouStocarstvo.propTypes = {
    dispatch: PropTypes.func
};

CreatePouStocarstvo.contextTypes = {
    router: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(CreatePouStocarstvo);